// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zekrom: PokeData = {
  "id": 644,
  "name": "zekrom",
  "height": 29,
  "weight": 3450,
  "base_experience": 306,
  "types": [
    PokeType.DRAGON,
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "dragon-rage",
    "thunderbolt",
    "thunder",
    "slash",
    "outrage",
    "dragon-breath",
    "crunch",
    "ancient-power",
    "imprison",
    "hyper-voice",
    "dragon-claw",
    "thunder-fang",
    "zen-headbutt",
    "bolt-strike",
    "fusion-bolt",
    "noble-roar"
  ],
  "moves": [
    "thunderbolt",
    "thunder",
    "outrage",
    "dragon-breath",
    "crunch",
    "ancient-power",
    "hyper-voice",
    "dragon-claw",
    "thunder-fang",
    "zen-headbutt",
    "dragon-rush",
    "draco-meteor",
    "thunder-punch"
  ],
  "evolution_chain": {
    "id": 331,
    "item": null,
    "species": [
      {
        "name": "zekrom",
        "order": 645,
        "types": [
          PokeType.DRAGON,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 122,
    "speed": 104,
    "ability_power": 174
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
